var e = {};
export {
  e as __exports
};
//# sourceMappingURL=react-is.development.mjs.map
